import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { Site } from 'modules/sites'
import { SITE_PATH, SITE_EDIT_PATH } from 'config'


const SiteItem = ({ site }) => {
  return (
    <div className="card mb-3 align-self-stretch">
      <div className="card-block">
        <Link
          className="float-right ml-3 text-lg"
          to={ SITE_EDIT_PATH.replace(':site', site.key) }>
          <i className="zmdi zmdi-settings" />
        </Link>
        <h4
          title={ site.name } className="m-0 text-ellipsis"
          style={ { lineHeight: '29px' } }>
          <Link
            className="btn-link"
            to={ SITE_PATH.replace(':site', site.key) }>
            { site.name }
          </Link>
        </h4>
      </div>
    </div>
  )
}

SiteItem.propTypes = {
  site: PropTypes.instanceOf(Site).isRequired,
}

export default SiteItem



// WEBPACK FOOTER //
// ./src/components/sites/site-item.js